import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  type?: 'child' | 'grandchild' | 'nav'
  opening?: boolean
  border?: boolean
}

const HierarchyRowList = ({ children, type, opening = true, border = false }: Props) => {
  return (
    <div className={clsx('accordion', opening && 'opening')}>
      <ul
        className={clsx(
          type == 'grandchild' && 'hierarchy-grandchild',
          type == 'child'
            ? 'hierarchy-child pl-4'
            : type == 'grandchild'
              ? 'pl-[30px]'
              : type == 'nav'
                ? 'pb-2'
                : 'w-full',
          border && 'border-primary border-b'
        )}
      >
        {children}
      </ul>
    </div>
  )
}

export default HierarchyRowList
